/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {Dispatch} from 'redux'
import {PageTitle} from '../../../_metronic/layout/core'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {getBillingDetails, getDashboardStatistics} from '../../../setup/redux/common/actions'
import {RootState} from '../../../setup'
import {MixedWidget2} from '../../../_metronic/partials/widgets'
import {ChartsWidget1} from '../../../_metronic/_partials/widgets/charts/ChartsWidget1'
import {DonutChart} from '../../../_metronic/_partials/widgets/charts/DonutChart'
import {getInspectionCompanies, getToolchainCredits} from '../../../setup/redux/auth/actions'
import {useNavigate} from 'react-router-dom'

const DashboardWrapper: FC = () => {
  const navigate = useNavigate()
  const dispatch: Dispatch<any> = useDispatch()
  const {statistics}: any = useSelector<RootState>((state) => state.common.statistics)
  const {active_inspection_company, tcc_balance, accesses}: any =
    useSelector<RootState>(
      (state) => ({
        active_inspection_company: state.auth.active_inspection_company,
        tcc_balance: state.auth.tcc_balance,
        accesses: state.auth.accesses,
      }),
      shallowEqual
    )

  React.useEffect(() => {
    if (!accesses) {
      navigate('/logout')
    }
  }, [])

  React.useEffect(() => {
    dispatch(getDashboardStatistics())
    dispatch(getInspectionCompanies(active_inspection_company?.id))
    dispatch(getBillingDetails())
  }, [])

  React.useEffect(() => {
    if (active_inspection_company?.id) {
      dispatch(getToolchainCredits(active_inspection_company.id))
    }
  }, [active_inspection_company])


  const DashboardPage: FC = () => (
    <>
      <div className='row gy-5 g-xl-8'>
        <div className='col-xxl-12'>
          <MixedWidget2
            className='card-xl-stretch mb-xl-8'
            chartColor='primary'
            chartHeight='200px'
            strokeColor='#e1f0ff'
            statistics={statistics}
            tcc_balance={tcc_balance}
          />
        </div>
      </div>
    </>
  )

  return (
    <>
      <PageTitle>Dashboard</PageTitle>
      <DashboardPage />
      <div className='row gutter-b'>
        <div className='col-xl-6'>
          {statistics?.barChart && (
            <ChartsWidget1 className='card-xl-stretch mb-xl-8' data={statistics.barChart} />
          )}
        </div>
        <div className='col-xl-6'>
          {statistics?.barChart && (
            <DonutChart className='card-xl-stretch mb-xl-8' data={statistics.inspectionData} />
          )}
        </div>
      </div>
    </>
  )
}

export {DashboardWrapper}
